import { CAMPAIGN_STATUSES } from '../model/campaign'
import type { CampaignStatus } from '../model/campaign'

/**
 * Which row actions a campaign will actually accept.
 *
 * `DELETE /campaigns/{id}` soft-deletes, and the service refuses one that is
 * still moving — "Running or paused campaigns must be stopped first." The menu
 * reads that rule out loud (a disabled item with the reason under it) rather
 * than letting the row fire a request the service was always going to bounce;
 * in this service a refusal comes back as a `400`, which would surface as the
 * generic "That did not go through" and teach the agent nothing.
 */
export function canDeleteCampaign(status: CampaignStatus): boolean {
  return (
    status !== CAMPAIGN_STATUSES.running && status !== CAMPAIGN_STATUSES.paused
  )
}

/**
 * Stop is the way out of that corner, so it is offered on exactly the statuses
 * that block a delete, plus `scheduled` — a campaign that has not started yet
 * is still on its way somewhere, and calling it off is the same intent.
 * `finished`, `stopped` and `draft` are already at rest.
 */
export function canStopCampaign(status: CampaignStatus): boolean {
  return (
    status === CAMPAIGN_STATUSES.running ||
    status === CAMPAIGN_STATUSES.paused ||
    status === CAMPAIGN_STATUSES.scheduled
  )
}
